// removed by extract-text-webpack-plugin
module.exports = {"marketType":"_1aR6bUtKyR5yCTzBvKoiYr","marketText":"_21aXJAgWtUSsotFJ5Wo4Yq","customButtonContainer":"_2_hbMJ4rKu-k4Fz8TdBRJb","innerText":"_9Osbo6SASMTQ8-VUkD2ko","buttonCustomStyle":"nDtSX3taq2wfJNyBg2Sem"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/baseball/css/oddsCard.css
// module id = 994
// module chunks = 0